module.exports = __webpack_public_path__ + "img/D.71e3129c.png";